const isValidDate = (date) => {
    const [yyyy, mm, dd] = date.split('-');
    return (!!yyyy &&
        yyyy.length === 4 &&
        !Number.isNaN(+yyyy) &&
        !!mm &&
        mm.length === 2 &&
        !Number.isNaN(+mm) &&
        !!dd &&
        dd.length === 2 &&
        !Number.isNaN(+dd));
};
const formatExpiryDate = (date) => {
    if (!isValidDate(date))
        return 'N/A';
    const [yyyy, mm] = date.split('-');
    return `${mm}/${yyyy}`;
};
export default formatExpiryDate;
//# sourceMappingURL=formatExpiryDate.js.map